import { render } from "./StockIcon.vue?vue&type=template&id=0cdc5b22&scoped=true"
import script from "./StockIcon.vue?vue&type=script&lang=js"
export * from "./StockIcon.vue?vue&type=script&lang=js"

import "./StockIcon.vue?vue&type=style&index=0&id=0cdc5b22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdc5b22"]])

export default __exports__